// extracted by mini-css-extract-plugin
export var modal = "_u9-0";
export var table = "_u9-1";